<template>
  <el-dialog title="Thông báo" :visible.sync="localVisible" width="520px" :append-to-body="false">
    <div>
      Bài tập có thời gian chấm vượt quá thời gian quy định để thanh tra.<br />
      Bạn có muốn làm mới với bài tập thanh tra này không?
    </div>
    <span slot="footer" class="dialog-footer">
      <button class="btn btn-light-gray font-weight-bold mr-2" @click="onCancel">
        <i class="fas fa-times"></i> Không
      </button>
      <button class="btn btn-purple font-weight-bold mr-2" @click="$emit('confirm')">
        <i v-if="loading" class="fas fa-spinner fa-spin mr-1"></i>
        <i v-else class="fas fa-check"></i> Có, tôi muốn làm mới BTVN
      </button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'RefreshAutoDialog',
  props: {
    visible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  computed: {
    localVisible: {
      get() { return this.visible; },
      set(v) { this.$emit('update:visible', v); }
    }
  },
  methods: {
    onCancel() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
    }
  }
}
</script>

<style scoped>
</style>


